import React from "react";
import SectionShell from "./SectionShell";

export default function UnitySection() {
  return (
    <SectionShell
      id="egyseg"
      testId="unity-section"
      eyebrow="Egy teremtő folyamat"
      titleStart="Az"
      titleAccent="egység"
      titleEnd=" nem egy távoli, megfoghatatlan fogalom"
      tinted
    >
      {/* Symbolic image — the unity, the wholeness */}
      <figure className="my-8 md:my-10">
        <div className="portrait-frame relative max-w-xl mx-auto">
          <img
            data-testid="unity-image"
            src="https://customer-assets.emergentagent.com/job_tiszta-tukor/artifacts/u116s3ja_egys%C3%A9g.png"
            alt="Egység — a belső és külső világ összefüggéseinek képi megjelenítése"
            className="w-full h-auto object-cover block"
            style={{
              aspectRatio: "1 / 1",
              filter: "saturate(0.96) contrast(1.02)",
            }}
            loading="lazy"
          />
        </div>
      </figure>

      <p>
        Sokan úgy gondolnak az egységre, mint valamire, amit majd egyszer elérünk. Amikor
        minden rendeződik, megszűnnek a konfliktusok és minden a helyére kerül. A hozzám
        érkezőkkel én úgy tekintek erre, mint egy teremtő folyamat. Elsősorban
        önmagunkban kell megteremtenünk az egységet… majd ezt tudjuk kiterjeszteni a
        szűkebb és tágabb környezetünkre. Az egység nem valahol a jövőben vár ránk és nem
        is egy tökéletes állapot. Sokkal inkább annak felismerése, hogy minden
        kapcsolatunk, minden találkozásunk és minden élethelyzetünk összefügg egymással.
      </p>

      {/* Centered gold highlight — clean, no rules */}
      <div className="my-6 md:my-8 text-center">
        <p className="font-serif-display italic text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-gold max-w-xl mx-auto">
          Mindannyian hatunk egymásra.
        </p>
      </div>

      <p>
        A döntéseink pedig hatással vannak a kapcsolatainkra. A kapcsolataink hatással
        vannak a családunkra. A családjaink hatással vannak a közösségeinkre. És
        mindennek részei vagyunk mi magunk is. Az egység ott kezdődik, amikor megszűnünk
        különálló problémákban gondolkodni és elkezdjük meglátni az összefüggéseket.
        Önmagunkban. A kapcsolatainkban. Az életünkben. Mert amikor valami a helyére
        kerül bennünk, annak hatása van mindenre, ami körülvesz bennünket. Nem azért,
        mert erőltetjük. Hanem mert a belső változás természetes módon jelenik meg a
        külvilágban is. Talán ezért nem egy távoli célról beszélünk. Hanem valamiről, ami
        minden nap ott van a kapcsolatainkban, a döntéseinkben és a választásainkban és
        minden alkalommal közelebb kerülünk hozzá, amikor egy kicsit közelebb kerülünk
        önmagunkhoz.
      </p>
    </SectionShell>
  );
}
